import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InvoiceListIssuedComponent } from './invoice-list-issued.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvoiceService } from './invoice.service';
import { ContabilizarModel } from './contabilizar.model';

@Component({
    selector: 'convfact-invoicecontabilized',
    templateUrl: './invoice-dialog-contabilizar.component.html',
    styleUrls: ['./invoice.component.css'],
    standalone: false
})
export class InvoiceDialogContabilizarComponent implements OnInit {
    uid: ContabilizarModel = this.data.uid;
    message: string[];
    ready = false;

    constructor(
        public dialogRef: MatDialogRef<InvoiceListIssuedComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public invoiceService: InvoiceService,
    ) { }

    ngOnInit() {
        this.invoiceService.assessAll(this.uid).then(result => {
            this.message = result;
            this.ready = true;
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }

  public trackByIndex(i: number) { return i; }

}